import React from 'react'
import { BreadCrumb } from './breadCrumb'
import { Container, BreadCrumbsList, CrumbDivider } from './styles'

interface IBreadCrumb {
  text: string
  handleClick: VoidFunction
}

export interface BreadCrumbsProps {
  breadCrumbsLevels: IBreadCrumb[]
}

/**
 * This component will render a bread crumbs with custom texts (levels) and callback click functions
 * @param {BreadCrumbsProps['breadCrumbsLevels']} array - Bread crumbs levels with text and click function
 * @returns {JSX.Element} return the rendered bread crumbs
 * @example
 * const [crumbs, setCrumbs] = useState([{text: 'Home', handleClick: () => {}}, {text: 'About', handleClick: () => {}}])
 * <BreadCrumbs breadCrumbsLevels={crumbs} />
 */

export const BreadCrumbs = ({ breadCrumbsLevels }: BreadCrumbsProps): JSX.Element => {
  return (
    <Container>
      <BreadCrumbsList>
        {breadCrumbsLevels.map((breadCrumb, index, array) => {
          const isLastCrumb = index === array.length - 1
          const { text, handleClick } = breadCrumb

          return (
            <React.Fragment key={index}>
              <BreadCrumb isLastCrumb={isLastCrumb} handleClick={handleClick}>
                {text}
              </BreadCrumb>
              {isLastCrumb ? null : <CrumbDivider />}
            </React.Fragment>
          )
        })}
      </BreadCrumbsList>
    </Container>
  )
}
